module.exports = __webpack_public_path__ + "static/avatar-d34a149f072ac067bcdfc2a2207cd2ad.jpg";